import { ReactNode, useMemo } from 'react';
import { useSession } from '@/services/providers/session-provider.tsx';
import { hasPermission, Permissions } from '@/features/users/schemas/users.permissions.ts';
import { Navigate } from 'react-router';

export const PermissionRoute = <Resource extends keyof Permissions>({
  children,
  resource,
  action,
  fallbackPath = '/dashboard',
}: {
  children: ReactNode;
  resource: Resource;
  action: Permissions[Resource]['action'];
  fallbackPath?: string;
}) => {
  const { userId, role } = useSession();

  const hasAccess = useMemo(
    () => hasPermission({ userId, role }, resource, action),
    [userId, role, resource, action]
  );

  if (!hasAccess) {
    return <Navigate to={fallbackPath} replace />;
  }

  if (role === 'Unknown') return null;

  return children;
};
